<template>
  <Teleport to="body">
    <Modal :show="isOpen">
      <template #header>
        <div class="d-flex flex-fill w-100 p-0">
          <span class="ms-auto me-0 right p-0" @click="handleClose">
            <i class="fa fa-times" style="font-size: larger !important"></i>
          </span>
        </div>
        <div class="d-flex flex-row">
          <h5 class="text-black fw-bolder text-center me-1 w-100">
            {{ title }}
          </h5>
        </div>
      </template>
      <template #body>
        <p class="text-center text-black fs-6">
          {{ message }}
        </p>
      </template>
      <template #footer>
        <button
          class="mt-3 text-center fw-bold modal-btn"
          @click="handleConfirm"
        >
          {{ confirmText }}
        </button>
        <button class="mt-3 text-center fw-bold modal-btn" @click="handleClose">
          {{ cancelText }}
        </button>
      </template>
    </Modal>
  </Teleport>
</template>

<script setup lang="ts">
import { ref } from "vue";
import Modal from "@/apps/credit-line/components/Modal.vue";

withDefaults(
  defineProps<{
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
  }>(),
  {
    confirmText: "Confirm",
    cancelText: "Cancel",
  }
);

const isOpen = ref(false);
const resolvePromise = ref(null);

const open = () => {
  isOpen.value = true;

  return new Promise((resolve) => {
    resolvePromise.value = resolve;
  });
};

const handleClose = () => {
  isOpen.value = false;
  resolvePromise.value(false);
};

const handleConfirm = () => {
  isOpen.value = false;
  resolvePromise.value(true);
};

defineExpose({ open });
</script>

<style scoped>
.modal-btn {
  width: 45%;
  border-radius: 10px;
  background: var(--main-primary-500, #2c7040);
  color: var(--main-white, #fff);
  height: 44px;
  text-align: center;
  font-size: medium;
  border: none;
}
</style>
